import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {catchError, Observable, of, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import {NGXLogger} from 'ngx-logger';
import { Segnalazione } from '../models/segnalazione.model';
import { Intervento } from '../models/intervento.model';
import { Evento } from '../models/evento.model';


@Injectable({
  providedIn: 'root',
})
export class EventiService{
  apiUrl: string = environment.apiUrl+"evento";

  constructor(
    private http: HttpClient,
    private logger: NGXLogger

    ) {}

  get(): Observable<any> {
    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };


    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl, httpOptions);
  }
  getByID(idEvento:string): Observable<any> {
    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };


    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl+"/"+idEvento, httpOptions);
  }


  getByTecnicoAndDataInizio(idTecnico:number): Observable<any> {
    const today = new Date();
    this.logger.info("--> getByTecnicoAndDataInizio "+ idTecnico );

    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // I mesi in JavaScript vanno da 0 a 11
    const day = String(today.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;

    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };

    let urlCompleto:string = this.apiUrl+"?tecnico="+idTecnico+"&data_inizio="+formattedDate;
    this.logger.info(urlCompleto );

    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(urlCompleto, httpOptions);
  }
  getByDataInizio(idTecnico:number): Observable<any> {
    const today = new Date();

    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // I mesi in JavaScript vanno da 0 a 11
    const day = String(today.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;

    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };


    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl+"?data_inizio="+formattedDate, httpOptions);
  }

  crea(evento:Evento): Observable<any> {

    const headers = {
    };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(this.apiUrl, evento, httpOptions);
  }

  eliminaCollegati(idEvento:string): Observable<any> {
    let url = this.apiUrl+"/cascade/"+idEvento;
    const headers = {
    };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.delete(url, httpOptions).pipe(
      tap((res: any) => {
        return res;
      }),
      catchError(this.handleError<any[]>('eliminasegnalazione', []))
    );
  }

  elimina(idEvento:string): Observable<any> {
    let url = this.apiUrl +"/"+idEvento;
    const headers = {
    };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.delete(url, httpOptions).pipe(
      tap((res: any) => {
        return res;
      }),
      catchError(this.handleError<any[]>('eliminasegnalazione', []))
    );
  }
  modifica(evento:Evento): Observable<any> {

    const headers = {
    //  'Authorization': `Bearer ${token}`,
    };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.put(this.apiUrl+"/"+evento.id, evento, httpOptions).pipe(
      tap((res: any) => {
        return res;
      }),
      catchError(this.handleError<any[]>('modificasegnalazione', []))
    );
  }


  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
   private handleError = <T>(operation = 'operation', result?: T) => {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      // this.logger.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      // this.logger.info(`${operation} failed: ${error.message}`);

      /*this.errorHandler.dialogConfig = {...this.dialogConfig};
      this.errorHandler.handleError(error);*/



      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  };
}
